import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import it from '@/locales/it.json';
import de from '@/locales/de.json';
import fr from '@/locales/fr.json';
import es from '@/locales/es.json';

const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en-US';

export const i18n = createI18n({
  legacy: false,
  locale: selectedLanguage,
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'it-IT': it,
    'de-DE': de,
    'fr-FR': fr,
    'es-ES': es,
  },
});
